import React from 'react';
import { Divider, Hurray } from '../../svg';
import IosArrowBack from '@meronex/icons/ios/IosArrowBack';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { toIndianRs } from '../../../../helpers';

const StepThree = ({
    setStep,
    selectedProject,
    furnishType,
    formattedDate,
    expectedRent,
    securityDeposit,
    setSelectedProject,
    setFurnishType,
    setRentOutTime,
    setExpectedRent,
    setSecurityDeposit,
    furnish,
    setFurnish,
   
}) => {
    const history = useHistory();

    const handleEnquiry = () => {
        history.push('/myprofile/enquiries');
    };
    return (
        <div className="w-full bg-white h-full flex items-center justify-center px-2 lg:px-0">
            <div className="w-[95%] lg:w-[40%] xl:w-[30%] mx-auto ">
                <div className="flex flex-col items-center justify-center mb-3">
                    {Hurray}

                    <h2 className="text-2xl font-bold mt-4">Hurray!</h2>
                    <p className="text-gray-400 mt-2 text-lg">
                        Successfully Placed your request.
                    </p>
                    <p className=" mb-6 mt-2 text-base">
                        Our team will get in touch with you with details shortly
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-4 mb-3 text-left">
                    
                       <div className={`flex items-center mb-4 justify-center`}>
                       {selectedProject?.image && (
                           <img
                               src={selectedProject?.image}
                               alt="Property"
                               className="w-24 h-20 rounded-md mr-4"
                           />
                       )}
                       <div>
                           <h3 className="font-semibold">
                               {selectedProject?.projectName}
                           </h3>

                           <p className=" text-gray-400 text-base">
                               {selectedProject?.configuration
                                   ? `${selectedProject.configuration}${selectedProject.configuration
                                       .toLowerCase()
                                       .includes('bhk')
                                       ? ''
                                       : ' BHK'
                                   } |`
                                   : ''}{' '}

                               {selectedProject?.unitArea
                                   ? ` ${selectedProject?.unitArea} ${' '}SqFt`
                                   : ''}
                           </p>
                       </div>
                   </div>
                 
                    {Divider}

                    <h4 className="font-bold text-gray-700 mb-2 mt-4 text-lg">
                        Other Details
                    </h4>

                    {/* Details Grid */}
                    <div className="grid grid-cols-2 gap-4 text-sm mt-2">
                        <div className="my-1">
                            <p className="text-gray-400 text-base">
                                EXPECTED RENT (INR)
                            </p>
                            <p className="font-bold mt-1 text-base">
                                {' '}
                                {toIndianRs(expectedRent)}
                            </p>
                        </div>
                        <div className="my-1">
                            <p className="text-gray-400 text-base">
                                SECURITY DEPOSIT (INR)
                            </p>
                            <p className="font-bold mt-1 text-base">
                                {toIndianRs(securityDeposit)}
                            </p>
                        </div>
                        <div className="my-1">
                            <p className="text-gray-400 text-base">HOW SOON</p>
                            <p className="font-bold mt-1 text-base">
                                {formattedDate}
                            </p>
                        </div>
                        <div className="my-1">
                            <p className="text-gray-400 text-base">
                                FURNISH TYPE
                            </p>
                            <p className="font-bold mt-1 text-base">
                                {furnish}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex justify-center items-center py-1">
                    <p className="px-4 pb-1">
                        You can manage your Enquires from {' '}
                        <a
                            className="text-primary font-semibold cursor-pointer"
                            onClick={handleEnquiry}
                        >
                            My Enquires
                        </a>{' '}
                        section under my profile
                    </p>
                </div>

                <div
                    onClick={() => {
                        window?.webengage?.track('BackToHomeClicked');
                        setSelectedProject(null);
                        setFurnishType(null);
                        setFurnish(null);
                        setExpectedRent(null);
                        setRentOutTime(null);
                        setSecurityDeposit(null);
                        setStep(1);
                    }}
                    className="flex items-center justify-center text-primary cursor-pointer py-1"
                >
                    <IosArrowBack className="inline text-xl" />
                    <p className="inline text-xl">Back to Home</p>
                </div>
            </div>
        </div>
    );
};

export default StepThree;
